export default {
    LOAD_LOTTERY_APP(state, lottery){
        state.items = lottery
    }
}